import React from 'react';
import { AlertTriangle, Construction, Sparkles } from 'lucide-react';

/**
 * Demo Banner Component
 * Use this to clearly label pages/features that use demo/simulated data
 */
export const DemoBanner = ({ 
  type = 'demo', // 'demo' | 'coming-soon' | 'preview'
  title,
  description,
  className = ''
}) => {
  const configs = {
    demo: {
      icon: AlertTriangle,
      bgColor: 'bg-amber-50 border-amber-200',
      iconColor: 'text-amber-600',
      textColor: 'text-amber-800',
      defaultTitle: 'Demo Data',
      defaultDescription: 'This page displays sample data for demonstration purposes. Real functionality coming soon.'
    },
    'coming-soon': {
      icon: Construction,
      bgColor: 'bg-blue-50 border-blue-200',
      iconColor: 'text-blue-600',
      textColor: 'text-blue-800',
      defaultTitle: 'Coming Soon',
      defaultDescription: 'This feature is under development and will be available in a future release.'
    },
    preview: {
      icon: Sparkles,
      bgColor: 'bg-purple-50 border-purple-200',
      iconColor: 'text-purple-600',
      textColor: 'text-purple-800',
      defaultTitle: 'Preview Feature',
      defaultDescription: 'This is a preview of upcoming functionality. Data shown may not reflect actual values.'
    }
  };

  const config = configs[type] || configs.demo;
  const Icon = config.icon;

  return (
    <div className={`${config.bgColor} border-2 rounded-lg p-4 mb-6 ${className}`}>
      <div className="flex items-start space-x-3">
        <Icon className={`h-5 w-5 ${config.iconColor} flex-shrink-0 mt-0.5`} />
        <div>
          <h4 className={`font-semibold ${config.textColor}`}>
            {title || config.defaultTitle}
          </h4>
          <p className={`text-sm ${config.textColor} opacity-80 mt-1`}>
            {description || config.defaultDescription}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
